export default "__VITE_ASSET__DYtTBakd__"